module.exports = __webpack_public_path__ + "img/ic_target.1ee8ecaf.jpg";